var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createIFrame, decode, getIframeWidth, getUrlParam, injectIframe, listenToEvent, submitToIframe } from './utils';
/**
 * Requests the ACS-based challenge page, presented in an iframe.
 * The iframe will be injected into the given selector.
 *
 * This method resolves once the browser exchange process is complete.
 */
export function browserExchange(data, timeout) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!data) {
            throw new Error('3DS output data missing.');
        }
        const iframe = createIFrame('browser-exchange', '1px', '1px');
        injectIframe(iframe);
        return request(data, performBrowserExchangeRequest, handleBrowserExchangeResponse, timeout, 'browser-exchange');
    });
}
/**
 * Requests the ACS-based challenge page, presented in an iframe.
 * The iframe will be injected into the given selector.
 *
 * This method resolves once the challenge has been submitted by the user.
 */
export function challenge(data, timeout, selector) {
    if (!data) {
        throw new Error('3DS output data missing.');
    }
    if (!document.querySelector(selector)) {
        throw new Error('Invalid DOM selector.');
    }
    const width = getIframeWidth(data.encodedCReq);
    const iframe = createIFrame('challenge', width, '100%');
    injectIframe(iframe, selector);
    return request(data, performChallengeRequest, handleChallengeResponse, timeout, 'challenge');
}
/**
 * Submits the 3ds method URL (browser exchange) form in the iframe.
 */
export function performBrowserExchangeRequest({ threeDSBrowserExchangeURL, browserExchangeCallbackUrl, threeDSServerTransID }, iframeId) {
    return __awaiter(this, void 0, void 0, function* () {
        const threeDSMethodData = JSON.stringify({
            threeDSMethodNotificationURL: threeDSBrowserExchangeURL,
            threeDSServerTransID
        });
        submitToIframe(browserExchangeCallbackUrl, iframeId, { threeDSMethodData });
        return listenToEvent();
    });
}
/**
 * Submits the challenge request (not the challenge itself) to the ACS.
 */
export function performChallengeRequest(data, iframeId) {
    return __awaiter(this, void 0, void 0, function* () {
        submitToIframe(data.acsURL, iframeId, {
            creq: data.encodedCReq
        });
        return listenToEvent();
    });
}
/**
 * Validates the postMessage response of the browser exchange notification page.
 */
export function handleBrowserExchangeResponse(data, response) {
    return __awaiter(this, void 0, void 0, function* () {
        const { threeDSMethodData } = decode(response.acsResponse);
        const { threeDSServerTransID } = decode(threeDSMethodData);
        if (data.threeDSServerTransID !== threeDSServerTransID) {
            return Promise.reject(new Error('3DS transaction ID mismatch.'));
        }
        else if (getUrlParam(data.browserExchangeCallbackUrl) !== response.callBackContext) {
            return Promise.reject(new Error('Browser exchange callback context mismatch.'));
        }
        return response;
    });
}
/**
 * Validates the postMessage response of the challenge notification page.
 */
export function handleChallengeResponse(data, response) {
    return __awaiter(this, void 0, void 0, function* () {
        if (getUrlParam(data.challengeCallbackUrl) !== response.callBackContext) {
            return Promise.reject(new Error('Notification URL mismatch.'));
        }
        return response;
    });
}
/**
 * Performs a request to the iframe having the given ID.
 */
export function request(request, requestHandler, responseHandler, timeout, iframeId) {
    return __awaiter(this, void 0, void 0, function* () {
        const timer = new Promise((resolve, reject) => setTimeout(reject, timeout));
        try {
            const response = yield Promise.race([timer, requestHandler(request, iframeId)]);
            if (!response.acsResponse) {
                return Promise.reject(new Error('acsResponse is missing from response.'));
            }
            return responseHandler(request, response);
        }
        catch (_) {
            return Promise.reject(new Error('3DS_TIMEOUT'));
        }
    });
}
